(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["erydez-g2-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('erydez-g2-story')) {
    customElements.define('erydez-g2-story', class extends HTMLElement {
      connectedCallback() {
        if (this.controller || this.dataset.ready !== 'true') return;
        this.controller = new AbortController();
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.compact = window.matchMedia('(max-height: 600px) and (orientation: landscape), (max-height: 480px)');
        this.imagesReady = false;
        this.layers = Object.fromEntries(Array.from(this.querySelectorAll('[data-layer]'), node => [node.dataset.layer, node]));
        this.captions = Array.from(this.querySelectorAll('[data-caption]'));
        this.stage = this.querySelector('.g2-story__stage');
        this.art = this.querySelector('.g2-story__art');
        this.progress = this.querySelector('.g2-story__progress > span');
        this.rays = this.querySelector('.g2-story__rays');
        this.impact = this.querySelector('.g2-story__impact');
        this.floor = this.querySelector('.g2-story__floor');
        this.stripe = this.querySelector('.g2-story__stripe');
        this.stamp = this.querySelector('.g2-story__stamp');
        this.playButton = this.querySelector('.g2-story__play');
        this.playText = this.playButton.querySelector('span');
        this.position = 0;
        this.rawPosition = 0;
        this.anchor = null;
        this.active = false;
        this.playing = false;
        this.frame = 0;
        this.captionIndex = -1;
        this.onScroll = () => {
          if (!this.active || this.playing || this.motionDisabled()) return;
          this.schedule();
        };
        this.onResize = () => this.schedule();
        this.onManualInput = event => {
          if (event.type === 'keydown' && !['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', ' '].includes(event.key)) return;
          if (event.type === 'keydown' && (event.target.closest('button, a, input, select, textarea') || event.target.isContentEditable)) return;
          if (this.playing) this.stopPlayback(true);
        };
        this.onVisibility = () => { if (document.hidden) this.stopPlayback(true); };
        this.onMotion = () => this.configureMotion();
        const eventOptions = { signal: this.controller.signal, passive: true };
        window.addEventListener('scroll', this.onScroll, eventOptions);
        window.addEventListener('resize', this.onResize, eventOptions);
        window.addEventListener('wheel', this.onManualInput, eventOptions);
        window.addEventListener('touchstart', this.onManualInput, eventOptions);
        window.addEventListener('keydown', this.onManualInput, { signal: this.controller.signal });
        document.addEventListener('visibilitychange', this.onVisibility, { signal: this.controller.signal });
        this.motion.addEventListener('change', this.onMotion);
        this.compact.addEventListener('change', this.onMotion);
        this.playButton.addEventListener('click', () => this.togglePlayback(), { signal: this.controller.signal });
        this.intersection = new IntersectionObserver(entries => {
          this.active = entries[0].isIntersecting;
          this.classList.toggle('is-active', this.active);
          if (this.active) this.schedule();
          else this.stopPlayback(true);
        }, { rootMargin: '120px 0px' });
        this.intersection.observe(this);
        this.configureMotion();
        this.prepareImages();
      }

      disconnectedCallback() {
        this.stopPlayback(false);
        if (this.frame) cancelAnimationFrame(this.frame);
        this.intersection?.disconnect();
        this.motion?.removeEventListener('change', this.onMotion);
        this.compact?.removeEventListener('change', this.onMotion);
        this.controller?.abort();
        this.controller = null;
      }

      configureMotion() {
        this.stopPlayback(false);
        this.anchor = null;
        this.classList.toggle('is-enhanced', !this.motionDisabled());
        if (this.motionDisabled()) this.paint(.7);
        else this.schedule();
      }

      motionDisabled() {
        return this.motion.matches || this.compact.matches || !this.imagesReady;
      }

      async prepareImages() {
        const connection = this.controller;
        const ready = await Promise.all(Array.from(this.querySelectorAll('.g2-story__image'), async image => {
          if (!image.complete) {
            await new Promise(resolve => {
              image.addEventListener('load', resolve, { once: true, signal: connection.signal });
              image.addEventListener('error', resolve, { once: true, signal: connection.signal });
              connection.signal.addEventListener('abort', resolve, { once: true });
            });
          }
          if (!image.naturalWidth) return false;
          try { await image.decode(); return true; } catch { return false; }
        }));
        if (this.controller !== connection || !this.isConnected) return;
        this.imagesReady = ready.length === 5 && ready.every(Boolean);
        this.configureMotion();
      }

      schedule() {
        if (this.frame || this.playing || !this.isConnected) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (this.motionDisabled()) return;
          this.rawPosition = this.readScroll();
          this.paint(this.mapScroll(this.rawPosition));
        });
      }

      readScroll() {
        const box = this.getBoundingClientRect();
        const top = Number.parseFloat(getComputedStyle(this.stage).top) || 0;
        const distance = Math.max(1, box.height - this.stage.offsetHeight);
        return Math.max(0, Math.min(1, (top - box.top) / distance));
      }

      mapScroll(raw) {
        if (!this.anchor) return raw;
        const { raw: start, position } = this.anchor;
        if (raw === start) return position;
        if (raw > start) return position + (raw - start) / (1 - start) * (1 - position);
        return position * raw / start;
      }

      stopPlayback(keepPosition) {
        if (!this.playing) return;
        this.playing = false;
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
        if (keepPosition) this.anchor = { raw: this.readScroll(), position: this.position };
        this.classList.remove('is-playing');
        this.playButton?.setAttribute('aria-pressed', 'false');
        if (this.playText) this.playText.textContent = this.position >= .995 ? this.dataset.replayLabel : this.dataset.playLabel;
      }

      togglePlayback() {
        if (this.motionDisabled()) return;
        if (this.playing) { this.stopPlayback(true); return; }
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
        const initial = this.position >= .995 ? 0 : this.position;
        this.playing = true;
        this.classList.add('is-playing');
        this.playButton.setAttribute('aria-pressed', 'true');
        this.playText.textContent = this.dataset.pauseLabel;
        const started = performance.now();
        const tick = now => {
          if (!this.playing || !this.isConnected || document.hidden) return;
          const next = Math.min(1, initial + (now - started) / 12000);
          this.paint(next);
          if (next < 1) this.frame = requestAnimationFrame(tick);
          else { this.frame = 0; this.stopPlayback(true); }
        };
        this.frame = requestAnimationFrame(tick);
      }

      paint(value) {
        const p = Math.max(0, Math.min(1, value));
        this.position = p;
        const smooth = (a, b) => {
          const x = Math.max(0, Math.min(1, (p - a) / (b - a)));
          return x * x * (3 - 2 * x);
        };
        const pulse = (a, b, c) => smooth(a, b) * (1 - smooth(b, c));
        const transform = (key, opacity, x, y, scale, rotate = 0, origin = '50% 50%') => {
          const layer = this.layers[key];
          if (!layer) return;
          layer.style.opacity = opacity.toFixed(4);
          layer.style.transformOrigin = origin;
          layer.style.transform = `translate3d(${x.toFixed(3)}%, ${y.toFixed(3)}%, 0) scale(${scale.toFixed(4)}) rotate(${rotate.toFixed(3)}deg)`;
        };
        const unbox = smooth(.075, .235);
        const sideZoom = smooth(.325, .435);
        const displayIn = smooth(.37, .455);
        const displayOut = smooth(.565, .66);
        const heroIn = smooth(.57, .675);
        const wheelZoom = smooth(.765, .875);
        const wheelIn = smooth(.81, .905);
        transform('box', 1 - smooth(.225, .255), 0, -5 + unbox * 70, .84 - unbox * .16, -unbox * 4);
        transform('side', smooth(.06, .085) * (1 - smooth(.38, .45)), sideZoom * 5, 6 * (1 - unbox) + sideZoom * 20, .5 + unbox * .42 + sideZoom * 2.4, -1.4 + unbox * 1.4, '40% 18%');
        transform('display', displayIn * (1 - displayOut), 0, -2 + displayOut * -8, .62 + displayIn * .44 - displayOut * .71, -5 + displayIn * 3 + displayOut * 7);
        transform('hero', heroIn * (1 - smooth(.825, .89)), wheelZoom * 14, wheelZoom * -26, .34 + heroIn * .6 + wheelZoom * 2.1, -5 * (1 - heroIn), '28% 77%');
        transform('wheel', wheelIn, 0, -2, .74 + wheelIn * .35 + smooth(.91, 1) * .05, -3 * (1 - wheelIn));
        const energy = Math.max(pulse(.07, .16, .25), pulse(.325, .415, .49), pulse(.565, .62, .7), pulse(.775, .86, .935));
        this.rays.style.opacity = (.06 + energy * .72).toFixed(4);
        this.rays.style.transform = `rotate(${(-4 + p * 8).toFixed(3)}deg) scale(${(1 + energy * .09).toFixed(4)})`;
        this.impact.style.opacity = (Math.max(pulse(.155, .19, .23), pulse(.395, .425, .47), pulse(.605, .635, .68), pulse(.84, .87, .915)) * .15).toFixed(4);
        this.floor.style.opacity = ((1 - displayIn + displayOut) * (1 - wheelZoom) * .8).toFixed(4);
        this.stripe.style.transform = `translate3d(${(-3 + p * 6).toFixed(3)}%, 0, 0) rotate(${(-12 - p * 6).toFixed(3)}deg)`;
        this.stamp.style.opacity = (1 - Math.min(1, energy * 1.8)).toFixed(4);
        this.progress.style.transform = `scaleX(${p.toFixed(5)})`;
        const index = p < .205 ? 0 : p < .405 ? 1 : p < .62 ? 2 : p < .85 ? 3 : 4;
        if (index !== this.captionIndex) {
          this.captionIndex = index;
          this.captions.forEach((caption, i) => {
            caption.classList.toggle('is-current', i === index);
            caption.setAttribute('aria-hidden', i === index ? 'false' : 'true');
          });
          const key = ['box', 'side', 'display', 'hero', 'wheel'][index];
          this.art.setAttribute('aria-label', this.layers[key].dataset.description);
        }
        if (!this.playing) this.playText.textContent = p >= .995 ? this.dataset.replayLabel : this.dataset.playLabel;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
